<div class="aza-activities-cart-list">
    <div *ngIf="!showAsSelectFields" class="aza-activities-cart-list-tabular-layout">
        <div class="aza-activities-cart-list">
            <ng-container *ngFor="let activity of filteredActivityCartItems">
                <div class="activity-name-start-end">
                    <div class="aza-text aza-heading activity-name">
                        <span>{{activity.cartActivity.name}}</span>
                    </div>
                    <div class="activity-start">
                        <span translate>START</span>:
                        <span>{{activity.cartActivity.start | eventDate:timezone:'date-time'}}</span>
                    </div>
                    <div class="activity-end">
                        <span translate>END</span>:
                        <span>{{activity.cartActivity.end | eventDate:timezone:'date-time'}}</span>
                    </div>
                </div>
                <div class="aza-activity-labels">
                    <div *ngIf="activity.showPlacesLeftLabel && !hideAvailablePlacesLeft" class="aza-activity-places-left-label">
                        <span>{{activity.cartActivity.places_left}}</span>&nbsp;
                        <span translate>PLACES_LEFT</span>
                    </div>
                    <span *ngIf="activity.showRegisteredLabel" class="aza-activity-registered-label"
                        translate>REGISTERED</span>
                    <span *ngIf="activity.showWaitingListLabel" class="aza-activity-waiting-list-label"
                        translate>WAITING_LIST</span>
                </div>
                <div class="aza-activity-action-buttons">
                    <button *ngIf="!activity.showNotAvailableButton && showAddToCalendar"
                        [popupMenuTriggerFor]="addToCalendarMenuRef" [popupMenuData]="{activityId: activity.cartActivity.id}"
                        class="aza-button aza-activity-add-to-calendar-button">
                            <span translate>{{translations.ADD_TO_CALENDAR}} </span>
                    </button>
                    <button *ngIf="activity.showRegisterButton" (click)="onAddToRegistration(activity)"
                        [disabled]="locked" class="aza-button aza-activity-register-button">
                        <span translate>REGISTER</span>
                    </button>
                    <button *ngIf="activity.showUnregisterButton" (click)="onRemoveFromRegistration(activity)"
                        [disabled]="locked" class="aza-button aza-activity-unregister-button">
                        <span translate>UNREGISTER</span>
                    </button>
                    <button *ngIf="activity.showNotAvailableButton"
                        [disabled]="locked" class="aza-button aza-disabled-button aza-activity-not-available-button">
                        <span translate>NOT_AVAILABLE</span>
                    </button>
                    <button *ngIf="activity.showWaitingListButton" (click)="onAddToRegistration(activity)"
                        [disabled]="locked" class="aza-button aza-activity-waiting-list-button">
                        <span translate>WAITING_LIST</span>
                    </button>
                </div>
                <span class="empty-grid-cell"></span>
            </ng-container>
        </div>
    </div>
    <div *ngIf="!showAsSelectFields" class="aza-vertical-stack aza-activities-cart-list-vertical-layout">
        <div *ngFor="let activity of filteredActivityCartItems" class="aza-activities-cart-list-item">
            <div class="aza-vertical-items-centered aza-horizontal-stack">
                <div class="aza-text aza-heading activity-name">
                    <span>{{activity.cartActivity.name}}</span>
                </div>
                <span class="empty-grid-cell"></span>
            </div>
            <div>
                <span translate>START</span>:
                <span>{{activity.cartActivity.start | eventDate:timezone:dateTimeFormat}}</span>
            </div>
            <div>
                <span translate>END</span>:
                <span>{{activity.cartActivity.end |eventDate:timezone:dateTimeFormat}}</span>
            </div>
            <div class="aza-activity-labels">
                <div *ngIf="activity.showPlacesLeftLabel && !hideAvailablePlacesLeft" class="aza-activity-places-left-label">
                    <span>{{activity.cartActivity.places_left}}</span>&nbsp;
                    <span translate>PLACES_LEFT</span>
                </div>
                <span *ngIf="activity.showRegisteredLabel" class="aza-activity-registered-label"
                    translate>REGISTERED</span>
                <span *ngIf="activity.showWaitingListLabel" class="aza-activity-waiting-list-label"
                    translate>WAITING_LIST</span>
            </div>
            <div class="aza-activity-action-buttons">
                <button *ngIf="!activity.showNotAvailableButton && showAddToCalendar"
                    [popupMenuTriggerFor]="addToCalendarMenuRef" [popupMenuData]="{activityId: activity.cartActivity.id}"
                    class="aza-button aza-activity-add-to-calendar-button">
                    <span translate>{{translations.ADD_TO_CALENDAR}}</span>
                </button>
                <button *ngIf="activity.showRegisterButton" (click)="onAddToRegistration(activity)"
                    [disabled]="locked" class="aza-button aza-activity-register-button">
                    <span translate>REGISTER</span>
                </button>
                <button *ngIf="activity.showUnregisterButton" (click)="onRemoveFromRegistration(activity)"
                    [disabled]="locked" class="aza-button aza-activity-unregister-button">
                    <span translate>UNREGISTER</span>
                </button>
                <button *ngIf="activity.showNotAvailableButton"
                    [disabled]="locked" class="aza-button aza-disabled-button aza-activity-not-available-button">
                    <span translate>NOT_AVAILABLE</span>
                </button>
                <button *ngIf="activity.showWaitingListButton" (click)="onAddToRegistration(activity)"
                    [disabled]="locked" class="aza-button aza-activity-waiting-list-button">
                    <span translate>WAITING_LIST</span>
                </button>
            </div>
        </div>
    </div>
    <div *ngIf="showAsSelectFields" class="aza-vertical-stack aza-activities-cart-list-select-fields-layout">
        <div *ngFor="let group of activityCartItemGroups; trackBy: getActivityCartItemGroupIdentifier" class="aza-activities-cart-list-group-item">
            <ng-container *ngIf="group.shownActivityItems > 0">
                <section class="section-h1 aza-section aza-theme aza-activities-cart-group-header">
                    <div class="aza-section-content aza-section-colors">
                        <div class="aza-text aza-heading">
                            {{group.name}}
                        </div>
                    </div>
                </section>
                <div class="section-form-single-column aza-section aza-theme aza-form aza-activities-cart-list__select-form">
                    <div class="aza-section-content aza-section-colors">
                        <div class="aza-form-field-area">
                            <div class="aza-input-field">
                                <div class="aza-field-content aza-field-type-select">
                                    <div class="aza-activities-cart-list-group-name">
                                        <label class="aza-text"></label>
                                    </div>
                                    <div class="aza-horizontal-stack">
                                        <select #selectActivityRef (change)="onGroupActivitySelected(group, $event)"
                                            class="aza-activities-cart-list-group-select-field">
                                            <option [disabled]="locked"></option>
                                            <ng-container *ngFor="let activityItem of group.activityItems">
                                                <option *ngIf="!activityItem.disabledByDependency"
                                                    [value]="activityItem.cartActivity.id"
                                                    [attr.selected]="activityItem.selected ? true : null"
                                                    [disabled]="activityItem.disabled || locked">
                                                    <span>{{activityItem.cartActivity.start |
                                                        eventDate:timezone:'time'}}</span>
                                                    <span>-</span>
                                                    <span>{{activityItem.cartActivity.end |
                                                        eventDate:timezone:'time'}}</span>
                                                    <span>&nbsp;</span>
                                                    <span>{{activityItem.cartActivity.name}}</span>
                                                    <ng-container *ngIf="activityItem.showPlacesLeftLabel && !hideAvailablePlacesLeft">
                                                        <span>, </span>
                                                        <span>{{activityItem.cartActivity.places_left}}</span>&nbsp;
                                                        <span translate>PLACES_LEFT</span>
                                                    </ng-container>
                                                    <ng-container *ngIf="activityItem.showNotAvailableButton">
                                                        <span>, </span>
                                                        <span translate>NOT_AVAILABLE</span>
                                                    </ng-container>
                                                    <ng-container
                                                        *ngIf="activityItem.showWaitingListButton || activityItem.showWaitingListLabel">
                                                        <span>, </span>
                                                        <span translate>WAITING_LIST</span>
                                                    </ng-container>
                                                    <ng-container *ngIf="activityItem.showRegisteredLabel">
                                                        <span>, </span>
                                                        <span translate>REGISTERED</span>
                                                    </ng-container>
                                                </option>
                                            </ng-container>
                                        </select>

                                        <button *ngIf="!!selectActivityRef.value && showAddToCalendar"
                                            [popupMenuTriggerFor]="addToCalendarMenuRef" [popupMenuData]="{activityId: selectActivityRef.value}"
                                            class="aza-button aza-activity-add-to-calendar-button"
                                            id="aza-activity-select-add-to-calendar-button">
                                            <span translate>{{translations.ADD_TO_CALENDAR}}</span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-container>
        </div>
    </div>
</div>

<ng-template #addToCalendarMenuRef matMenuContent let-activityId="activityId">
    <button class="aza-rw-popup-menu__item" (click)="openCalendar(activityId, calendarType.google)">
        <img src="assets/img/google-calendar-icon.svg">
        Google
    </button>
    <button class="aza-rw-popup-menu__item" (click)="openCalendar(activityId, calendarType.outlookLive)">
        <img src="assets/img/outlook-icon.svg">
        Outlook Live
    </button>
    <button class="aza-rw-popup-menu__item" (click)="openCalendar(activityId, calendarType.ics)">
        <img src="assets/img/outlook-icon.svg">
        Outlook
    </button>
    <button class="aza-rw-popup-menu__item" (click)="openCalendar(activityId, calendarType.ics)">
        <img src="assets/img/apple-black-icon.svg">
        Apple
    </button>
    <button class="aza-rw-popup-menu__item" (click)="openCalendar(activityId, calendarType.ics)">
        <img src="assets/img/ics-icon.svg">
        ICS
    </button>
</ng-template>

